
import React from "react";

interface FilterContainerProps {
  children: React.ReactNode;
  title?: string;
}

const FilterContainer: React.FC<FilterContainerProps> = ({ 
  children, 
  title = "Filters" 
}) => {
  return (
    <div className="md:col-span-1 space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-4 flex items-center">
          {title}
        </h3>
        
        <div className="space-y-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FilterContainer;
